/**
 * Single source of truth for the staff email domain allowlist.
 *
 * Consumed by both the API server (`requireStaff`) and the web client
 * (`isStaffUser`) so the two can never drift about who counts as staff.
 */
export const STAFF_DOMAINS = [
  "consultran.com",
  "donnormanassociates.com",
] as const;

/**
 * Whether the given email address belongs to a staff domain.
 *
 * Returns `false` for missing/empty input or addresses without a domain.
 */
export function isStaffDomainEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const domain = email.split("@")[1]?.toLowerCase();
  return domain
    ? (STAFF_DOMAINS as readonly string[]).includes(domain)
    : false;
}
